import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=72a1a500"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"
import style0 from "./TheBanner.vue?vue&type=style&index=0&id=72a1a500&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports